import React from "react";
import ContentPage from "../components/ContentPage";
import { LOGO_ANIMATED } from "../constants";

export default function IntroducingPage() {
  return (
    <ContentPage title="Introducing Top Screen&#8482;">
      <div className="prose prose-invert max-w-none" data-testid="intro-content">
        <p className="neon-white-text text-lg mb-6">
          Top Screen&#8482; is the revolutionary picture-in-picture solution that puts you in control of your screen real estate. 
          Whether you're monitoring a video call, watching live sports, keeping an eye on stock tickers, or following a tutorial — 
          Top Screen&#8482; keeps your content visible, always on top, on every device you own.
        </p>

        <h2 className="font-heading text-2xl font-semibold text-white mt-10 mb-4">Our Mission</h2>
        <p className="text-[#E8E4DC] mb-6">
          To empower users with ultimate screen flexibility, enabling seamless multitasking and content viewing 
          across all platforms and devices. We believe your most important content should never be hidden behind another window.
        </p>

        <h2 className="font-heading text-2xl font-semibold text-white mt-10 mb-4">What Makes Us Different</h2>
        <div className="grid gap-4 mb-8">
          {[
            { t: "True Always-On-Top", d: "Unlike native PiP which only works with videos, Top Screen™ can overlay ANY content — tabs, apps, documents, dashboards — over everything, including your lock screen." },
            { t: "Customizable Frames", d: "Choose from Classic, RGB Backlight, Neon Glow, or Shadow frame styles. Adjust colors, border width, and enable Theatre Mode for a cinematic experience." },
            { t: "Cross-Platform", d: "One license covers Chrome/Edge Extension, Windows 11 Desktop App, and iOS/Android Mobile App. Your settings and account sync everywhere." },
            { t: "Team Collaboration", d: "Share and manage Top Screen™ displays across your entire team. Perfect for war rooms, trading floors, and remote collaboration." },
            { t: "Built-in Timers & Alarms", d: "Schedule content to pop up at specific times. Never miss a meeting, a market open, or a deadline again." },
          ].map((item, i) => (
            <div key={i} className="card-glass p-5">
              <h3 className="text-[#A3E635] font-semibold mb-2">{item.t}</h3>
              <p className="text-[#E8E4DC]">{item.d}</p>
            </div>
          ))}
        </div>

        <h2 className="font-heading text-2xl font-semibold text-white mt-10 mb-4">Available On</h2>
        <div className="grid grid-cols-2 md:grid-cols-5 gap-4 mb-8">
          {[
            { name: "Chrome", icon: "/chrome-icon.png" },
            { name: "Edge", icon: "/edge-icon.png" },
            { name: "Windows 11", icon: "/windows-icon.png" },
            { name: "iOS", icon: "/ios-icon.png" },
            { name: "Android", icon: "/android-icon.png" },
          ].map((p, i) => (
            <div key={i} className="card-glass p-4 text-center" data-testid={`available-on-${p.name.toLowerCase().replace(/\s+/g, '-')}`}>
              <span
                aria-label={p.name}
                role="img"
                className="block w-10 h-10 mx-auto mb-2 bg-[#A3E635]"
                style={{
                  WebkitMaskImage: `url(${p.icon})`,
                  maskImage: `url(${p.icon})`,
                  WebkitMaskRepeat: "no-repeat",
                  maskRepeat: "no-repeat",
                  WebkitMaskPosition: "center",
                  maskPosition: "center",
                  WebkitMaskSize: "contain",
                  maskSize: "contain",
                }}
              />
              <p className="text-white text-sm font-medium">{p.name}</p>
            </div>
          ))}
        </div>

        <h2 className="font-heading text-2xl font-semibold text-white mt-10 mb-4">The Team</h2>
        <p className="text-[#E8E4DC] mb-4">
          Top Screen&#8482; is a product of <a href="https://713consulting.net/" target="_blank" rel="noopener noreferrer" className="text-[#A3E635] hover:underline">713 Consulting &amp; Development</a>, 
          based in Houston, Texas. Founded by Keith Bolden, 713 C&amp;D specializes in innovative software solutions 
          that solve real-world productivity challenges.
        </p>
        <p className="text-[#E8E4DC]">
          For inquiries, partnerships, or support: <span className="text-[#A3E635]">713.328.9736</span> | 
          <span className="text-[#A3E635]"> topscreen70126@outlook.com</span>
        </p>

        <div className="mt-10 text-center">
          <img src={LOGO_ANIMATED} alt="Top Screen Demo" className="w-72 mx-auto" />
        </div>
      </div>
    </ContentPage>
  );
}
